<template>
  <div>
    <Breadcrumb msg1="预约分诊" msg2="预约管理" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5">
          <el-date-picker v-model="query.appointment_date" type="date" value-format="yyyy-MM-dd" placeholder="预约日期"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="待确认" value="待确认"></el-option>
            <el-option label="已确认" value="已确认"></el-option>
            <el-option label="已到店" value="已到店"></el-option>
            <el-option label="已取消" value="已取消"></el-option>
            <el-option label="爽约" value="爽约"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.channel" placeholder="渠道" clearable>
            <el-option label="线下" value="线下"></el-option>
            <el-option label="线上" value="线上"></el-option>
            <el-option label="电话" value="电话"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增预约</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="日期" prop="appointmentDate" width="110"></el-table-column>
        <el-table-column label="时段" prop="timeSlot" width="100"></el-table-column>
        <el-table-column label="渠道" prop="channel" width="80"></el-table-column>
        <el-table-column label="科室" width="100"><template slot-scope="scope">{{ deptName(scope.row.departmentId) }}</template></el-table-column>
        <el-table-column label="医生" width="100"><template slot-scope="scope">{{ doctorNameOf(scope.row.doctorId) }}</template></el-table-column>
        <el-table-column label="事由" prop="reason" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="320">
          <template slot-scope="scope">
            <el-button size="mini" type="success" v-if="scope.row.status === '待确认'" @click="act(scope.row.id, 'confirm')">确认</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.status === '已确认'" @click="act(scope.row.id, 'arrive')">到店</el-button>
            <el-button size="mini" type="warning" v-if="['待确认', '已确认'].indexOf(scope.row.status) >= 0" @click="cancel(scope.row)">取消</el-button>
            <el-button size="mini" type="danger" v-if="scope.row.status === '已确认'" @click="act(scope.row.id, 'noshow')">爽约</el-button>
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="600px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-form-item label="客户" required>
          <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select v-model="form.channel" style="width: 100%">
            <el-option label="线下" value="线下"></el-option>
            <el-option label="线上" value="线上"></el-option>
            <el-option label="电话" value="电话"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约日期">
          <el-date-picker v-model="form.appointment_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="时段">
          <el-input v-model="form.time_slot" placeholder="如 09:00-10:00"></el-input>
        </el-form-item>
        <el-form-item label="科室">
          <el-select v-model="form.department_id" style="width: 100%">
            <el-option v-for="d in departments" :key="d.id" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生">
          <el-select v-model="form.doctor_id" style="width: 100%">
            <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事由">
          <el-input v-model="form.reason" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, appointment_date: '', status: '', channel: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      customerOptions: [],
      departments: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/departments').then(r => { if (r.data.status === 200) this.departments = r.data.data || [] })
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
  },
  methods: {
    customerName,
    deptName (id) { const d = this.departments.find(x => x.id === id); return d ? d.name : '' },
    doctorNameOf (id) { const d = this.doctors.find(x => x.id === id); return d ? d.realname : '' },
    getData () {
      this.$axios.get('/appointments', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    statusType (s) {
      return { 待确认: 'warning', 已确认: 'primary', 已到店: 'success', 已取消: 'info', 爽约: 'danger' }[s] || ''
    },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    add () {
      this.dialogTitle = '新增预约'
      this.form = { customer_id: null, channel: '线下', appointment_date: '', time_slot: '', department_id: null, doctor_id: null, reason: '' }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑预约'
      this.form = Object.assign({}, row, {
        customer_id: row.customerId,
        appointment_date: row.appointmentDate,
        time_slot: row.timeSlot,
        department_id: row.departmentId,
        doctor_id: row.doctorId
      })
      this.customerOptions = [{ id: row.customerId, name: customerName(row.customerId), phone: '' }]
      this.show = true
    },
    save () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      if (this.form.id) {
        this.$axios.put(`/appointments/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/appointments', () => { this.show = false; this.getData() }, this.form)
      }
    },
    act (id, action) {
      this.$axios.put(`/appointments/${id}/${action}`, () => this.getData())
    },
    cancel (row) {
      this.$prompt('请输入取消原因', '取消预约', { inputPattern: /\S+/, inputErrorMessage: '原因不能为空' }).then(({ value }) => {
        this.$axios.put(`/appointments/${row.id}/cancel`, () => this.getData(), { reason: value })
      }).catch(() => {})
    }
  }
}
</script>
